import { Component } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";

import { AuthenticationService } from "./_services";
import { User } from "./_models";
import { HostListener } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

declare const gtag: Function;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  title = "doctorbusiness";
  currentUrl = null;
  currentUser: User;
  currentUserInfo = null;
  classToggled = false;
  scrollTop = false;
  cookieBar = false;

  constructor(private route: ActivatedRoute, private router: Router, private authenticationService: AuthenticationService, private translate: TranslateService) {
    this.currentUserInfo = this.authenticationService.currentUserInfo;
    this.authenticationService.currentUser.subscribe((x) => (this.currentUser = x));

    this.translate.setDefaultLang("ro");

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      /** START : Code to Track Page View  */
      gtag("event", "page_view", {
        page_path: event.urlAfterRedirects,
      });
      /** END */
    });

    let referrer = document.referrer;
    if (referrer.includes("mobilpay")) {
      gtag("event", "conversion", {
        send_to: "AW-10836247105/lzwGCMrlu6kDEMGEkK8o",
        transaction_id: "",
      });
    }
  }

  ngOnInit() {
    this.currentUrl = window.location.pathname;

    // document.cookie = 'cookie-notice=true';

    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");

    if (!this.getCookie("cookie-notice")) {
      this.cookieBar = true;
    }
  }

  public switchLanguage(language: string) {
    this.translate.use(language);
  }

  public getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  public cookieConsent() {
    document.cookie = "cookie-notice=true";
    if (this.getCookie("cookie-notice") == "true") {
      let element = document.getElementById("cookie-notice");
      element.className = "hide";
    }
  }

  logout() {
    this.authenticationService.logout();
    window.location.href = "/";
    // this.router.navigate(['/']);
  }

  expandMenu() {
    document.querySelector(".ant-menu").classList.add("show");
  }

  public toggleField() {
    this.classToggled = !this.classToggled;
  }

  public goTop() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  @HostListener("window:scroll", []) onWindowScroll() {
    let scroll = window.pageYOffset;
    if (scroll > 500) {
      this.scrollTop = true;
    } else {
      this.scrollTop = false;
    }
  }

  ngOnDestroy() { }
}
